import createSpinner from "../../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function (helperService, configurationDataService, $filter) {

    const vm = this;

    vm.submitLicensing = submitLicensing;
    vm.helperService = helperService;
    vm.configNames = [
        'AX7_UseObjectLicensing',
    ];

    vm.$onInit = activate;

    async function activate() {
        await getLicenses();
        vm.originalLicenseTypes = structuredClone(vm.licenseTypes);
        vm.originalLicenseSkus = structuredClone(vm.licenseSkus);
        vm.config = { ...vm.currentConfig };
        vm.origConfig = { ...vm.originalConfig };
    }

    async function getLicenses() {
        let { data: licenseTypes } = await configurationDataService.getLicenses();
        let { data: licenseSkus } = await configurationDataService.getLicenseSkus();

        vm.licenseTypes = $filter('orderBy')(licenseTypes, 'Priority');
        vm.licenseSkus = $filter('orderBy')(licenseSkus, 'Priority');
    }

    async function submitLicensing() {
        vm.updateSettingsPending = new createSpinner();

        try {
            let updateLicensingConfigs = await configValuesHaveChanged(vm.configNames)
            if (updateLicensingConfigs) {
                updateLicensingConfigValues(); 
            }

            vm.licenseTypes.forEach(async item => {
                let index = vm.originalLicenseTypes.findIndex(origVal => origVal.LicenseId === item.LicenseId);
                let orig = vm.originalLicenseTypes[index];

                if (item.Price !== orig.Price || item.AadSkuId !== orig.AadSkuId) {
                    let typePutData = {
                        LicenseId: item.LicenseId,
                        Price: item.Price,
                        AadSkuId: item.AadSkuId
                    };

                    await configurationDataService.updateLicenses(typePutData, item.LicenseId);
                }
            });

            vm.licenseSkus.forEach(async item => {
                let index = vm.originalLicenseSkus.findIndex(origVal => origVal.LicenseSkuId === item.LicenseSkuId);
                let orig = vm.originalLicenseSkus[index];

                if (item.BasePrice !== orig.BasePrice || item.AttachPrice !== orig.AttachPrice || item.AadSkuId !== orig.AadSkuId) {
                    let skuPutData = {
                        LicenseSkuId: item.LicenseSkuId,
                        BasePrice: item.BasePrice,
                        AttachPrice: item.AttachPrice,
                        AadSkuId: item.AadSkuId
                    };

                    await configurationDataService.updateLicenseSkus(skuPutData, item.LicenseSkuId);
                }
            });

            await helperService.successfulSaveButton(vm.updateSettingsPending);
        } catch {
            vm.updateSettingsPending.loadingValue = false;
        }
    }

    function configValuesHaveChanged(configArray) {
        return helperService.returnTrueIfValuesDiffer(configArray, vm.origConfig, vm.config);
    }

    async function updateLicensingConfigValues() {
        vm.updateSettingsPending = new createSpinner();

        let list = [
            { Name: "AX7_UseObjectLicensing", Encrypted: false }
        ];

        try {
            let value = vm.config;
            let origVal = vm.origConfig;
            await vm.updateConfiguration({ list, value, origVal });
            await helperService.successfulSaveButton(vm.updateSettingsPending);
        } catch {
            vm.updateSettingsPending.loadingValue = false;
        }
    }
}